import React from 'react';
import Nav from './Nav';

const Layout = ({ children }) => {
  return (
    <div className="page-wrapper">
      <Nav />
      {children}
      <div className="body-border">
        <div className="body-border-corner-top-right w-embed">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 16V0C16 8.83656 8.83656 16 0 16H16Z" fill="white"></path>
          </svg>
        </div>
        <div className="body-border-corner-bottom-right w-embed">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 16V0C16 8.83656 8.83656 16 0 16H16Z" fill="white"></path>
          </svg>
        </div>
        <div className="body-border-corner-bottom-left w-embed">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 16V0C16 8.83656 8.83656 16 0 16H16Z" fill="white"></path>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Layout;

